import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppreciation = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2792_151941)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.48242 1.12988C7.97566 0.739664 8.74106 1.18091 8.5918 1.84082L7.83301 5.18457L9.96973 5.67188C10.4984 5.79258 10.6947 6.44253 10.3213 6.83594L5.53027 11.8838C5.05257 12.387 4.21231 11.9635 4.33301 11.2803L4.89746 8.08496L3.01855 7.65234C2.49952 7.53257 2.2989 6.8997 2.6543 6.50293L7.3877 1.21973L7.48242 1.12988Z",
			fill: "#8C81F7",
			stroke: "#D1CDFC"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2792_151941",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 13,
			height: 13,
			fill: "white"
		})
	}) })]
});
export default SvgAppreciation;
